import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const testimonials = [{
  quote: 'Envié 12 mensajes el lunes usando el guion del libro. El martes ya tenía $35 en mi cuenta de PayPal. No lo podía creer.',
  initial: 'M',
  name: 'María G.',
  subtitle: 'Venezuela · Resultado en 24h'
}, {
  quote: 'Nunca pensé que organizar correos me pagaría $20 en una tarde. El método es más simple de lo que parece desde afuera.',
  initial: 'C',
  name: 'Carlos R.',
  subtitle: 'México · Primera tarde'
}, {
  quote: 'Era muy escéptico. Dudé antes de comprar. Recuperé el precio del libro completo en las primeras 4 horas de haberlo aplicado.',
  initial: 'A',
  name: 'Ana L.',
  subtitle: 'Colombia · Recuperó inversión en 4h'
}];
export const Testimonials = () => {
  return <section className="py-20 md:py-24 bg-[#0a0a0a]" data-id="element-156">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-157">
        <FadeIn data-id="element-158">
          <div className="text-center mb-14" data-id="element-159">
            <span className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-sm mb-4 block" data-id="element-160">
              Resultados reales
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-id="element-161">
              Esto es lo que pasa cuando activas el protocolo
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-162">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.15} data-id="element-163">
              <div className="bg-[#111111] border border-white/10 border-t-2 border-t-[#ADFF2F] rounded-xl p-6 md:p-7 h-full flex flex-col hover:border-t-[#ADFF2F] hover:shadow-[0_0_30px_rgba(173,255,47,0.1)] transition-shadow" data-id="element-164">
                {/* Stars */}
                <div className="flex gap-1 mb-4" data-id="element-165">
                  {[...Array(5)].map((_, idx) => <Star key={idx} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-166" />)}
                </div>

                {/* Quote */}
                <p className="text-white italic text-base md:text-lg leading-relaxed mb-6 font-sans flex-1" data-id="element-167">
                  "{t.quote}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-white/5" data-id="element-168">
                  <div className="w-11 h-11 rounded-full bg-[#ADFF2F] flex items-center justify-center shrink-0" data-id="element-169">
                    <span className="text-black font-bold text-lg font-sans" data-id="element-170">
                      {t.initial}
                    </span>
                  </div>
                  <div data-id="element-171">
                    <p className="text-white font-semibold font-sans text-sm" data-id="element-172">
                      {t.name}
                    </p>
                    <p className="text-gray-500 text-xs font-sans" data-id="element-173">
                      {t.subtitle}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};